<section>
  <div class="header astral-page-header">
    <h1>{{ 'VAT_REPORT.TITLE' | translate }}</h1>
    <div class="astral-page-header__actions">
      <astral-button variant="primary" size="small" type="button" icon="print" labelKey="PRINT_BTN" (click)="onPrintPages()"></astral-button>
      <astral-button variant="primary" size="small" type="button" icon="excel" labelKey="COMMON.EXCEL" (click)="exportExcel()"></astral-button>
    </div>
  </div>

  <form class="filter astral-section-surface astral-form-stack astral-form-stack--relaxed report-filter-surface" [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <astral-layout-group [columns]="6" [tabletColumns]="2" [mobileColumns]="1">
      <astral-select [control]="form.controls['company']" [itemsSource]="companies"></astral-select>
      <astral-date-picker [control]="form.controls['periodFrom']"></astral-date-picker>
      <astral-date-picker [control]="form.controls['periodTo']"></astral-date-picker>
    </astral-layout-group>
    <div class="astral-filter-actions">
      <astral-button variant="primary" size="small" type="submit" icon="search" labelKey="SEARCH_BTN"></astral-button>
    </div>
  </form>

  @if (dataContext) {
    <app-list-view
      [columnDefinition]="columnDefinitions"
      [itemsSource]="dataContext.vatPerInvoice"
      [preferencesKey]="'report.vat'"
      (rowClick)="onRowClicked($event)"
    ></app-list-view>
  }
</section>
